import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation, Output, EventEmitter, Inject, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { OneDialogConfirmationService, OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { Subject } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReminderMessageTemplateDialogComponent } from '../reminder-message-template-dialog/reminder-message-template-dialog.component';
import { AddOwnTemplateDialogComponent } from '../../../add-own-template-dialog/add-own-template-dialog.component';
import { QnSbnService } from '../../../../services/qn-sbn-service.service';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'dl-reminder-message-template',
  templateUrl: './reminder-message-template.component.html',
  styleUrls: ['./reminder-message-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReminderMessageTemplateComponent implements OnInit {
  // public isNewTemplateAdded = false;
  public formDisabled = false;
  public selectPlaceholder = 'Select type...';
  public selectWidth = '150px';
  // @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input() public isNewFromTemplate: boolean;
  @Input() public addRowData: Subject<any>;
  @Input() public displayedColumns = []; // for template it will include "select" column header and for new no need "select"
  @Input() public tableData = []; // for new single row and for template dynamic no of row will be pass
  @Output() public isFeedbackOptionAdded = new EventEmitter<{ isOptAdded: boolean }>();
  @Output() public isReminderRowSelected = new EventEmitter<{ messageSelected: any[] }>();
  public dataSource = new MatTableDataSource<any>(this.tableData);
  public selection = new SelectionModel<any>(true, []);
  public selectedRow;

  public selectRadioTextFormControl = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);
  public msgAttachDataFormGroup = new FormGroup({
    selectTextFormControl: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)])
  });

  public editMessageFlag = false;
  public templateRTE;


  public constructor(private readonly dialog: MatDialog, public dialogRef: MatDialogRef<ReminderMessageTemplateDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private changeDetectorRef: ChangeDetectorRef, private qnsbnservice: QnSbnService, private confirmationDialog?: OneDialogConfirmationService, private readonly oneSnackBar?: OneSnackBarService) { }

  public ngOnInit(): void {
    this.addRowData.subscribe(data => {
      //  this.dataSource.data = data.placement === 'before' ? [...data.templateData, ...this.dataSource.data] : [...this.dataSource.data, ...data.templateData];
      this.dataSource.data = data.templateData;
    });
    this.dataSource.data = this.tableData;
  }

  public drop(event: CdkDragDrop<string[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
    this.dataSource.data = JSON.parse(JSON.stringify(this.dataSource.data));
  }



  // public deleteReminderFromTemplate(elm: any, index: number): void {
  //   // TODO: need to integrate backend services to delete from template
  //   const deleteDialogRef = this.confirmationDialog.open('Delete message template', 'Are you sure you want to delete this message template from your templates?', 'Yes, delete', 'Cancel');

  //   deleteDialogRef.afterClosed().subscribe((confirmed: boolean) => {
  //     if (confirmed) {
  //       this.dataSource.data = this.dataSource.data.filter(item => item !== elm);
  //       this.oneSnackBar.open('Reminder template successfully deleted from your templates.', OneSnackBarType.SUCCESS);
  //     }
  //   });
  // }

  public deleteReminderFromTemplate(elm: any, index: number): void {
    const deleteDialogRef = this.confirmationDialog.open('Delete reminder template', 'Are you sure you want to delete this reminder template from your templates?', 'Yes, delete', 'Cancel');

    deleteDialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.qnsbnservice.deleteMessageTemplate(elm.templateId).subscribe(
          (data: any) => {
            if (data.errorMessage) {
              this.oneSnackBar.open(data.errorMessage.errorMessage, OneSnackBarType.ERROR, '', { duration: 5000 });
            } else {
              this.dataSource.data = this.dataSource.data.filter(item => item.templateId !== elm.templateId);
              this.changeDetectorRef.detectChanges();
              this.oneSnackBar.open('Reminder template successfully deleted from your templates.', OneSnackBarType.SUCCESS);
            }
          },
          (error: HttpErrorResponse) => {
            // console.log('error:', error);
            this.qnsbnservice.httpErrorHandler(error, 'Could not fetch reminder templates.');
          }
        );
      }
    });
  }

  // public deleteFeedbackOption(elm: any, index: number): void {}

  public updateSelectRowStatus(): void {
    // this.cfFtDialogService.getSelectedRowInTemplate(this.selection.selected);
    this.isReminderRowSelected.emit({ messageSelected: this.selection.selected });
  }

  public EditMessageTemplate(i): void {
    const dialogRef = this.dialog.open(AddOwnTemplateDialogComponent, {
      data: { tableData: this.dataSource.data[i], columnData: [], rowIndex: i, allTemplates: this.dataSource.data, messageType: 'Reminder' },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(editEntry => {
      if (editEntry.rowIndex >= 0) {
        this.dataSource.data = editEntry.data;
        this.changeDetectorRef.detectChanges();
        this.oneSnackBar.open('Reminder template changes successfully saved', OneSnackBarType.SUCCESS);
      }
      // this.dataSource.data[editEntry.data.newTableData.rowIndex].selectText = editEntry.data.newTableData.subject;
      // this.dataSource.data[editEntry.data.newTableData.rowIndex].messageTemplate = editEntry.data.newTableData.RTEText;
      // this.changeDetectorRef.detectChanges();
      // this.oneSnackBar.open('Changes successfully saved', OneSnackBarType.SUCCESS);
    });
  }

  public getHTMLRTEText(evt?): void {
    this.templateRTE = evt;
  }
}
